const routers = [
    {
        path: '/idiom',
        meta: {
            title: '成语查询'
        },
        component:  require('../components/pages/idiom-finder.vue').default
    },
    {
        path: '/update_log',
        meta: {
            title: '更新日志'
        },
        component:  require('../components/pages/update-log.vue').default
    },
    {
        path:"/",
        meta:{
            title:'姓名生成器'
        },
        component:  require('../components/pages/name-generator.vue').default
    }
];
export default routers;
